<template>
  <div class="">
    <!--
    <div class="top">
      <svg-icon icon-class="sdpt" class="logo"></svg-icon>
    </div>
    <div class="cont">
      <div class="title">微信扫码登录</div>
      <div id="login-code"></div>
    </div>
    -->
  </div>
</template>

<script>
import '@/utils/wxLogin.js'

export default {
  data: function () {
    return {}
  },
  created() {
    if (typeof WeixinJSBridge !== "undefined") {
      window.location.href = "https://authserver.sdpt.edu.cn/public/api/authenticate/plugin_wechat/sdxyplugin_wechat/homepage?targetUrl=https%3A%2F%2Fauthserver.sdpt.edu.cn%2Fapi%2Fbff%2Fv1.2%2Fenduser%2Fportal%2Fsso%2Fgo_716b8b9b0b15bdb0f3f59c455c68d9baN9HHU5KlSPy"
    } else {
      window.location.href = "https://authserver.sdpt.edu.cn/oauth/authorize?response_type=code&scope=read&client_id=5b8fab88a0e" +
          "67389b1019cf3e0233873ZFPtaiPjufq&redirect_uri=https%3" +
          "A%2F%2Fsdpt.profly.com.cn%2Fauth&state=8bf9b8c3b9f8b1" +
          "a169d8c1abe2545fc04rLkCvuel3i_idp&prompt=login"
    }
  },
  mounted: function () {
    //this.getWxCode()
  },
  methods: {
    getWxCode() {
      this.WxLogin = new WxLogin({
        self_redirect: false,
        id: 'login-code',
        appid: "wxcf06bfef7bebf2d2",
        scope: 'snsapi_login',
        //redirect_uri: "https://www.weprofly.com/web/login/loginWx?cid=<?=$cid?>&gid=<?=$gid?>",
        redirect_uri: 'https://sdpt.profly.com.cn/oauth',
        state: '',
        style: '',
        stylelite: 1,
        // href: process.env.VUE_APP_API_URL_HTTPS + '/static/csss/qrcode.css?v=3',
      })
    },
  }
}
</script>

<style lang="less" scoped>

.top {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(---normal, #E2E4E9);
  box-shadow: 0px 2px 12px 0px rgba(68, 73, 77, 0.13);
  height: 80px;
  box-sizing: border-box;

  .logo {
    width: 195px;
    height: 46px;
    margin: 0 0 0 40px;

  }
}

.cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 100px);

  .title {
    font-size: 24px;
    font-weight: 500;
    margin: 0 0 20px;
  }

  #login-code {
    height: 160px;
    margin: 0 auto;
  }

}


</style>